var _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 498,
    height: 392,
    viewBox: "0 0 498 392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 496,
    height: 390,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 55,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 55,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 55,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317,
    y: 55,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407,
    y: 55,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 103,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 103,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 103,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317,
    y: 103,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407,
    y: 103,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_ii_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 151,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 151,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 151,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317,
    y: 151,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407,
    y: 151,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_ii_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 199,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 199,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 199,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317,
    y: 199,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407,
    y: 199,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_ii_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 247,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 247,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 247,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317,
    y: 247,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407,
    y: 247,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_ii_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 295,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 295,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 295,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317,
    y: 295,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407,
    y: 295,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_ii_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 343,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 343,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter32_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 343,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter33_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317,
    y: 343,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 407,
    y: 343,
    width: 90,
    height: 48,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter34_i_1780_27988)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 450,
    height: 54,
    transform: "translate(47 1)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4648 11.4688H80.7773L83.2441 18.0488L85.7051 11.4688H87.0176L83.7598 20H82.7168L79.4648 11.4688ZM78.8672 11.4688H80.1152L80.332 17.1641V20H78.8672V11.4688ZM86.3672 11.4688H87.6211V20H86.1504V17.1641L86.3672 11.4688ZM96.1699 15.5V15.9688C96.1699 16.6133 96.0859 17.1914 95.918 17.7031C95.75 18.2148 95.5098 18.6504 95.1973 19.0098C94.8887 19.3691 94.5176 19.6445 94.084 19.8359C93.6504 20.0234 93.1699 20.1172 92.6426 20.1172C92.1191 20.1172 91.6406 20.0234 91.207 19.8359C90.7773 19.6445 90.4043 19.3691 90.0879 19.0098C89.7715 18.6504 89.5254 18.2148 89.3496 17.7031C89.1777 17.1914 89.0918 16.6133 89.0918 15.9688V15.5C89.0918 14.8555 89.1777 14.2793 89.3496 13.7715C89.5215 13.2598 89.7637 12.8242 90.0762 12.4648C90.3926 12.1016 90.7656 11.8262 91.1953 11.6387C91.6289 11.4473 92.1074 11.3516 92.6309 11.3516C93.1582 11.3516 93.6387 11.4473 94.0723 11.6387C94.5059 11.8262 94.8789 12.1016 95.1914 12.4648C95.5039 12.8242 95.7441 13.2598 95.9121 13.7715C96.084 14.2793 96.1699 14.8555 96.1699 15.5ZM94.6992 15.9688V15.4883C94.6992 15.0117 94.6523 14.5918 94.5586 14.2285C94.4688 13.8613 94.334 13.5547 94.1543 13.3086C93.9785 13.0586 93.7617 12.8711 93.5039 12.7461C93.2461 12.6172 92.9551 12.5527 92.6309 12.5527C92.3066 12.5527 92.0176 12.6172 91.7637 12.7461C91.5098 12.8711 91.293 13.0586 91.1133 13.3086C90.9375 13.5547 90.8027 13.8613 90.709 14.2285C90.6152 14.5918 90.5684 15.0117 90.5684 15.4883V15.9688C90.5684 16.4453 90.6152 16.8672 90.709 17.2344C90.8027 17.6016 90.9395 17.9121 91.1191 18.166C91.3027 18.416 91.5215 18.6055 91.7754 18.7344C92.0293 18.8594 92.3184 18.9219 92.6426 18.9219C92.9707 18.9219 93.2617 18.8594 93.5156 18.7344C93.7695 18.6055 93.9844 18.416 94.1602 18.166C94.3359 17.9121 94.4688 17.6016 94.5586 17.2344C94.6523 16.8672 94.6992 16.4453 94.6992 15.9688ZM104.408 11.4688V20H102.938L99.1113 13.8887V20H97.6406V11.4688H99.1113L102.949 17.5918V11.4688H104.408Z",
    fill: "#71757A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 39,
    r: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9062 33.4555V44.8696H87.0234V35.6899L84.2344 36.6352V35.0805L88.6797 33.4555H88.9062ZM100.484 43.3696V44.8696H92.8594V43.5805L96.5625 39.5414C96.9688 39.0831 97.2891 38.6873 97.5234 38.3539C97.7578 38.0206 97.9219 37.7211 98.0156 37.4555C98.1146 37.1847 98.1641 36.9217 98.1641 36.6664C98.1641 36.3071 98.0964 35.992 97.9609 35.7211C97.8307 35.4451 97.638 35.2289 97.3828 35.0727C97.1276 34.9112 96.8177 34.8305 96.4531 34.8305C96.0312 34.8305 95.6771 34.9217 95.3906 35.1039C95.1042 35.2862 94.888 35.5388 94.7422 35.8618C94.5964 36.1795 94.5234 36.544 94.5234 36.9555H92.6406C92.6406 36.294 92.7917 35.6899 93.0938 35.143C93.3958 34.5909 93.8333 34.1534 94.4062 33.8305C94.9792 33.5024 95.6693 33.3383 96.4766 33.3383C97.237 33.3383 97.8828 33.4659 98.4141 33.7211C98.9453 33.9763 99.349 34.3383 99.625 34.8071C99.9062 35.2758 100.047 35.8305 100.047 36.4711C100.047 36.8253 99.9896 37.1769 99.875 37.5258C99.7604 37.8748 99.5964 38.2237 99.3828 38.5727C99.1745 38.9164 98.9271 39.2628 98.6406 39.6118C98.3542 39.9555 98.0391 40.3045 97.6953 40.6586L95.2344 43.3696H100.484Z",
    fill: "#3D4043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.377 11.4688V20H173.918V11.4688H175.377ZM178.055 11.4688V12.6406H171.264V11.4688H178.055ZM183.967 11.4688H185.432V17.1699C185.432 17.8184 185.291 18.3613 185.01 18.7988C184.729 19.2363 184.346 19.5664 183.861 19.7891C183.381 20.0078 182.844 20.1172 182.25 20.1172C181.637 20.1172 181.09 20.0078 180.609 19.7891C180.129 19.5664 179.75 19.2363 179.473 18.7988C179.199 18.3613 179.062 17.8184 179.062 17.1699V11.4688H180.527V17.1699C180.527 17.5801 180.598 17.918 180.738 18.1836C180.879 18.4453 181.078 18.6387 181.336 18.7637C181.594 18.8887 181.898 18.9512 182.25 18.9512C182.602 18.9512 182.904 18.8887 183.158 18.7637C183.416 18.6387 183.615 18.4453 183.756 18.1836C183.896 17.918 183.967 17.5801 183.967 17.1699V11.4688ZM192.615 18.834V20H188.086V18.834H192.615ZM188.502 11.4688V20H187.031V11.4688H188.502ZM192.023 15.0312V16.1797H188.086V15.0312H192.023ZM192.586 11.4688V12.6406H188.086V11.4688H192.586Z",
    fill: "#71757A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 182,
    cy: 39,
    r: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.906 33.4555V44.8696H177.023V35.6899L174.234 36.6352V35.0805L178.68 33.4555H178.906ZM185.07 38.3305H186.195C186.633 38.3305 186.995 38.255 187.281 38.1039C187.573 37.9529 187.789 37.7446 187.93 37.4789C188.07 37.2133 188.141 36.9086 188.141 36.5649C188.141 36.2055 188.076 35.8982 187.945 35.643C187.82 35.3826 187.628 35.1821 187.367 35.0414C187.112 34.9008 186.786 34.8305 186.391 34.8305C186.057 34.8305 185.755 34.8982 185.484 35.0336C185.219 35.1638 185.008 35.3513 184.852 35.5961C184.695 35.8357 184.617 36.1222 184.617 36.4555H182.727C182.727 35.8513 182.885 35.3149 183.203 34.8461C183.521 34.3774 183.953 34.0102 184.5 33.7446C185.052 33.4737 185.672 33.3383 186.359 33.3383C187.094 33.3383 187.734 33.4607 188.281 33.7055C188.833 33.9451 189.263 34.3045 189.57 34.7836C189.878 35.2628 190.031 35.8565 190.031 36.5649C190.031 36.8878 189.956 37.2159 189.805 37.5493C189.654 37.8826 189.43 38.1873 189.133 38.4633C188.836 38.7342 188.466 38.9555 188.023 39.1274C187.581 39.294 187.068 39.3774 186.484 39.3774H185.07V38.3305ZM185.07 39.7993V38.768H186.484C187.151 38.768 187.719 38.8461 188.188 39.0024C188.661 39.1586 189.047 39.3748 189.344 39.6508C189.641 39.9217 189.857 40.2315 189.992 40.5805C190.133 40.9295 190.203 41.2993 190.203 41.6899C190.203 42.2211 190.107 42.6951 189.914 43.1118C189.727 43.5232 189.458 43.8722 189.109 44.1586C188.76 44.4451 188.352 44.6612 187.883 44.8071C187.419 44.9529 186.914 45.0258 186.367 45.0258C185.878 45.0258 185.409 44.9581 184.961 44.8227C184.513 44.6873 184.112 44.4868 183.758 44.2211C183.404 43.9503 183.122 43.6144 182.914 43.2133C182.711 42.8071 182.609 42.3383 182.609 41.8071H184.492C184.492 42.1456 184.57 42.4451 184.727 42.7055C184.888 42.9607 185.112 43.1612 185.398 43.3071C185.69 43.4529 186.023 43.5258 186.398 43.5258C186.794 43.5258 187.135 43.4555 187.422 43.3149C187.708 43.1743 187.927 42.9659 188.078 42.6899C188.234 42.4138 188.312 42.0805 188.312 41.6899C188.312 41.2472 188.227 40.8878 188.055 40.6118C187.883 40.3357 187.638 40.1326 187.32 40.0024C187.003 39.867 186.628 39.7993 186.195 39.7993H185.07Z",
    fill: "#3D4043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.006 18.084L263.705 11.4688H264.596L264.496 13.1738L262.68 20H261.754L262.006 18.084ZM260.734 11.4688L262.111 18.0312L262.234 20H261.25L259.275 11.4688H260.734ZM266.523 18.0137L267.883 11.4688H269.348L267.373 20H266.389L266.523 18.0137ZM264.941 11.4688L266.623 18.1016L266.869 20H265.943L264.156 13.1738L264.062 11.4688H264.941ZM276.021 18.834V20H271.492V18.834H276.021ZM271.908 11.4688V20H270.438V11.4688H271.908ZM275.43 15.0312V16.1797H271.492V15.0312H275.43ZM275.992 11.4688V12.6406H271.492V11.4688H275.992ZM279.701 20H277.879L277.891 18.834H279.701C280.229 18.834 280.67 18.7188 281.025 18.4883C281.385 18.2578 281.654 17.9277 281.834 17.498C282.018 17.0684 282.109 16.5566 282.109 15.9629V15.5C282.109 15.0391 282.057 14.6309 281.951 14.2754C281.85 13.9199 281.697 13.6211 281.494 13.3789C281.295 13.1367 281.049 12.9531 280.756 12.8281C280.467 12.7031 280.133 12.6406 279.754 12.6406H277.844V11.4688H279.754C280.32 11.4688 280.838 11.5645 281.307 11.7559C281.775 11.9434 282.18 12.2148 282.52 12.5703C282.863 12.9258 283.127 13.3516 283.311 13.8477C283.494 14.3438 283.586 14.8984 283.586 15.5117V15.9629C283.586 16.5762 283.494 17.1309 283.311 17.627C283.127 18.123 282.863 18.5488 282.52 18.9043C282.176 19.2559 281.766 19.5273 281.289 19.7188C280.816 19.9062 280.287 20 279.701 20ZM278.693 11.4688V20H277.223V11.4688H278.693Z",
    fill: "#71757A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 272,
    cy: 39,
    r: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.906 33.4555V44.8696H267.023V35.6899L264.234 36.6352V35.0805L268.68 33.4555H268.906ZM280.695 40.8149V42.3149H272.492L272.43 41.1821L277.336 33.4946H278.844L277.211 36.2914L274.391 40.8149H280.695ZM279.273 33.4946V44.8696H277.391V33.4946H279.273Z",
    fill: "#3D4043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.377 11.4688V20H352.918V11.4688H354.377ZM357.055 11.4688V12.6406H350.264V11.4688H357.055ZM363.816 15.0312V16.1973H359.287V15.0312H363.816ZM359.65 11.4688V20H358.18V11.4688H359.65ZM364.947 11.4688V20H363.482V11.4688H364.947ZM371.486 11.4688H372.951V17.1699C372.951 17.8184 372.811 18.3613 372.529 18.7988C372.248 19.2363 371.865 19.5664 371.381 19.7891C370.9 20.0078 370.363 20.1172 369.77 20.1172C369.156 20.1172 368.609 20.0078 368.129 19.7891C367.648 19.5664 367.27 19.2363 366.992 18.7988C366.719 18.3613 366.582 17.8184 366.582 17.1699V11.4688H368.047V17.1699C368.047 17.5801 368.117 17.918 368.258 18.1836C368.398 18.4453 368.598 18.6387 368.855 18.7637C369.113 18.8887 369.418 18.9512 369.77 18.9512C370.121 18.9512 370.424 18.8887 370.678 18.7637C370.936 18.6387 371.135 18.4453 371.275 18.1836C371.416 17.918 371.486 17.5801 371.486 17.1699V11.4688Z",
    fill: "#71757A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 39,
    r: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.906 33.4555V44.8696H357.023V35.6899L354.234 36.6352V35.0805L358.68 33.4555H358.906ZM364.836 39.5805L363.336 39.2133L363.953 33.4946H370.086V35.0883H365.516L365.203 37.8774C365.38 37.7732 365.625 37.6717 365.938 37.5727C366.25 37.4685 366.607 37.4164 367.008 37.4164C367.544 37.4164 368.023 37.505 368.445 37.6821C368.872 37.8539 369.234 38.1065 369.531 38.4399C369.828 38.768 370.055 39.169 370.211 39.643C370.367 40.1118 370.445 40.6404 370.445 41.2289C370.445 41.755 370.367 42.2472 370.211 42.7055C370.06 43.1638 369.831 43.5675 369.523 43.9164C369.216 44.2654 368.828 44.5388 368.359 44.7368C367.896 44.9295 367.346 45.0258 366.711 45.0258C366.237 45.0258 365.781 44.9581 365.344 44.8227C364.911 44.6821 364.523 44.4763 364.18 44.2055C363.836 43.9295 363.56 43.5909 363.352 43.1899C363.143 42.7836 363.023 42.3175 362.992 41.7914H364.836C364.883 42.1612 364.984 42.4763 365.141 42.7368C365.302 42.992 365.516 43.1873 365.781 43.3227C366.047 43.4581 366.354 43.5258 366.703 43.5258C367.021 43.5258 367.294 43.4711 367.523 43.3618C367.753 43.2472 367.943 43.0857 368.094 42.8774C368.25 42.6638 368.365 42.4138 368.438 42.1274C368.516 41.8409 368.555 41.5232 368.555 41.1743C368.555 40.8409 368.51 40.5362 368.422 40.2602C368.339 39.9842 368.211 39.7446 368.039 39.5414C367.872 39.3383 367.661 39.1821 367.406 39.0727C367.151 38.9581 366.857 38.9008 366.523 38.9008C366.076 38.9008 365.732 38.9659 365.492 39.0961C365.258 39.2263 365.039 39.3878 364.836 39.5805Z",
    fill: "#3D4043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.338 11.4688V20H443.867V11.4688H445.338ZM448.818 15.2012V16.3672H444.963V15.2012H448.818ZM449.305 11.4688V12.6406H444.963V11.4688H449.305ZM450.477 11.4688H453.494C454.143 11.4688 454.695 11.5664 455.152 11.7617C455.609 11.957 455.959 12.2461 456.201 12.6289C456.447 13.0078 456.57 13.4766 456.57 14.0352C456.57 14.4609 456.492 14.8359 456.336 15.1602C456.18 15.4844 455.959 15.7578 455.674 15.9805C455.389 16.1992 455.049 16.3691 454.654 16.4902L454.209 16.707H451.496L451.484 15.541H453.518C453.869 15.541 454.162 15.4785 454.396 15.3535C454.631 15.2285 454.807 15.0586 454.924 14.8438C455.045 14.625 455.105 14.3789 455.105 14.1055C455.105 13.8086 455.047 13.5508 454.93 13.332C454.816 13.1094 454.641 12.9395 454.402 12.8223C454.164 12.7012 453.861 12.6406 453.494 12.6406H451.947V20H450.477V11.4688ZM455.346 20L453.342 16.168L454.883 16.1621L456.916 19.9238V20H455.346ZM459.605 11.4688V20H458.135V11.4688H459.605Z",
    fill: "#71757A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 452,
    cy: 39,
    r: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.906 33.4555V44.8696H447.023V35.6899L444.234 36.6352V35.0805L448.68 33.4555H448.906ZM458.547 33.4243H458.781V34.9633H458.648C457.977 34.9633 457.396 35.0675 456.906 35.2758C456.422 35.4842 456.023 35.7706 455.711 36.1352C455.398 36.4998 455.164 36.9269 455.008 37.4164C454.857 37.9008 454.781 38.4164 454.781 38.9633V40.7524C454.781 41.2055 454.831 41.6065 454.93 41.9555C455.029 42.2993 455.167 42.5883 455.344 42.8227C455.526 43.0519 455.734 43.2263 455.969 43.3461C456.203 43.4659 456.456 43.5258 456.727 43.5258C457.008 43.5258 457.263 43.4685 457.492 43.3539C457.721 43.2342 457.917 43.0701 458.078 42.8618C458.24 42.6534 458.362 42.406 458.445 42.1196C458.529 41.8331 458.57 41.5206 458.57 41.1821C458.57 40.8592 458.529 40.5571 458.445 40.2758C458.367 39.9894 458.25 39.7394 458.094 39.5258C457.938 39.3071 457.742 39.1378 457.508 39.018C457.279 38.893 457.013 38.8305 456.711 38.8305C456.336 38.8305 455.995 38.919 455.688 39.0961C455.385 39.2732 455.141 39.505 454.953 39.7914C454.771 40.0727 454.672 40.3722 454.656 40.6899L453.938 40.4555C453.979 39.9711 454.086 39.5362 454.258 39.1508C454.435 38.7654 454.667 38.4373 454.953 38.1664C455.24 37.8956 455.57 37.6899 455.945 37.5493C456.326 37.4034 456.742 37.3305 457.195 37.3305C457.747 37.3305 458.227 37.4347 458.633 37.643C459.039 37.8513 459.375 38.1352 459.641 38.4946C459.911 38.8487 460.112 39.255 460.242 39.7133C460.378 40.1664 460.445 40.6404 460.445 41.1352C460.445 41.6821 460.362 42.1925 460.195 42.6664C460.029 43.1352 459.784 43.5467 459.461 43.9008C459.143 44.255 458.755 44.531 458.297 44.7289C457.844 44.9269 457.328 45.0258 456.75 45.0258C456.141 45.0258 455.596 44.9086 455.117 44.6743C454.643 44.4399 454.24 44.117 453.906 43.7055C453.578 43.294 453.328 42.8201 453.156 42.2836C452.984 41.7472 452.898 41.1795 452.898 40.5805V39.7993C452.898 38.9347 453.008 38.1196 453.227 37.3539C453.445 36.5831 453.781 35.9034 454.234 35.3149C454.693 34.7263 455.279 34.2654 455.992 33.9321C456.706 33.5935 457.557 33.4243 458.547 33.4243Z",
    fill: "#3D4043"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.543 105.875V107H17.8242V106.033L20.6016 103.004C20.9062 102.66 21.1465 102.363 21.3223 102.113C21.498 101.863 21.6211 101.639 21.6914 101.439C21.7656 101.236 21.8027 101.039 21.8027 100.848C21.8027 100.578 21.752 100.342 21.6504 100.139C21.5527 99.9316 21.4082 99.7695 21.2168 99.6523C21.0254 99.5312 20.793 99.4707 20.5195 99.4707C20.2031 99.4707 19.9375 99.5391 19.7227 99.6758C19.5078 99.8125 19.3457 100.002 19.2363 100.244C19.127 100.482 19.0723 100.756 19.0723 101.064H17.6602C17.6602 100.568 17.7734 100.115 18 99.7051C18.2266 99.291 18.5547 98.9629 18.9844 98.7207C19.4141 98.4746 19.9316 98.3516 20.5371 98.3516C21.1074 98.3516 21.5918 98.4473 21.9902 98.6387C22.3887 98.8301 22.6914 99.1016 22.8984 99.4531C23.1094 99.8047 23.2148 100.221 23.2148 100.701C23.2148 100.967 23.1719 101.23 23.0859 101.492C23 101.754 22.877 102.016 22.7168 102.277C22.5605 102.535 22.375 102.795 22.1602 103.057C21.9453 103.314 21.709 103.576 21.4512 103.842L19.6055 105.875H23.543ZM30.3633 105.875V107H24.6445V106.033L27.4219 103.004C27.7266 102.66 27.9668 102.363 28.1426 102.113C28.3184 101.863 28.4414 101.639 28.5117 101.439C28.5859 101.236 28.623 101.039 28.623 100.848C28.623 100.578 28.5723 100.342 28.4707 100.139C28.373 99.9316 28.2285 99.7695 28.0371 99.6523C27.8457 99.5312 27.6133 99.4707 27.3398 99.4707C27.0234 99.4707 26.7578 99.5391 26.543 99.6758C26.3281 99.8125 26.166 100.002 26.0566 100.244C25.9473 100.482 25.8926 100.756 25.8926 101.064H24.4805C24.4805 100.568 24.5938 100.115 24.8203 99.7051C25.0469 99.291 25.375 98.9629 25.8047 98.7207C26.2344 98.4746 26.752 98.3516 27.3574 98.3516C27.9277 98.3516 28.4121 98.4473 28.8105 98.6387C29.209 98.8301 29.5117 99.1016 29.7188 99.4531C29.9297 99.8047 30.0352 100.221 30.0352 100.701C30.0352 100.967 29.9922 101.23 29.9062 101.492C29.8203 101.754 29.6973 102.016 29.5371 102.277C29.3809 102.535 29.1953 102.795 28.9805 103.057C28.7656 103.314 28.5293 103.576 28.2715 103.842L26.4258 105.875H30.3633Z",
    fill: "#71757A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.543 153.875V155H17.8242V154.033L20.6016 151.004C20.9062 150.66 21.1465 150.363 21.3223 150.113C21.498 149.863 21.6211 149.639 21.6914 149.439C21.7656 149.236 21.8027 149.039 21.8027 148.848C21.8027 148.578 21.752 148.342 21.6504 148.139C21.5527 147.932 21.4082 147.77 21.2168 147.652C21.0254 147.531 20.793 147.471 20.5195 147.471C20.2031 147.471 19.9375 147.539 19.7227 147.676C19.5078 147.812 19.3457 148.002 19.2363 148.244C19.127 148.482 19.0723 148.756 19.0723 149.064H17.6602C17.6602 148.568 17.7734 148.115 18 147.705C18.2266 147.291 18.5547 146.963 18.9844 146.721C19.4141 146.475 19.9316 146.352 20.5371 146.352C21.1074 146.352 21.5918 146.447 21.9902 146.639C22.3887 146.83 22.6914 147.102 22.8984 147.453C23.1094 147.805 23.2148 148.221 23.2148 148.701C23.2148 148.967 23.1719 149.23 23.0859 149.492C23 149.754 22.877 150.016 22.7168 150.277C22.5605 150.535 22.375 150.795 22.1602 151.057C21.9453 151.314 21.709 151.576 21.4512 151.842L19.6055 153.875H23.543ZM26.3027 150.096H27.1465C27.4746 150.096 27.7461 150.039 27.9609 149.926C28.1797 149.812 28.3418 149.656 28.4473 149.457C28.5527 149.258 28.6055 149.029 28.6055 148.771C28.6055 148.502 28.5566 148.271 28.459 148.08C28.3652 147.885 28.2207 147.734 28.0254 147.629C27.834 147.523 27.5898 147.471 27.293 147.471C27.043 147.471 26.8164 147.521 26.6133 147.623C26.4141 147.721 26.2559 147.861 26.1387 148.045C26.0215 148.225 25.9629 148.439 25.9629 148.689H24.5449C24.5449 148.236 24.6641 147.834 24.9023 147.482C25.1406 147.131 25.4648 146.855 25.875 146.656C26.2891 146.453 26.7539 146.352 27.2695 146.352C27.8203 146.352 28.3008 146.443 28.7109 146.627C29.125 146.807 29.4473 147.076 29.6777 147.436C29.9082 147.795 30.0234 148.24 30.0234 148.771C30.0234 149.014 29.9668 149.26 29.8535 149.51C29.7402 149.76 29.5723 149.988 29.3496 150.195C29.127 150.398 28.8496 150.564 28.5176 150.693C28.1855 150.818 27.8008 150.881 27.3633 150.881H26.3027V150.096ZM26.3027 151.197V150.424H27.3633C27.8633 150.424 28.2891 150.482 28.6406 150.6C28.9961 150.717 29.2852 150.879 29.5078 151.086C29.7305 151.289 29.8926 151.521 29.9941 151.783C30.0996 152.045 30.1523 152.322 30.1523 152.615C30.1523 153.014 30.0801 153.369 29.9355 153.682C29.7949 153.99 29.5938 154.252 29.332 154.467C29.0703 154.682 28.7637 154.844 28.4121 154.953C28.0645 155.062 27.6855 155.117 27.2754 155.117C26.9082 155.117 26.5566 155.066 26.2207 154.965C25.8848 154.863 25.584 154.713 25.3184 154.514C25.0527 154.311 24.8418 154.059 24.6855 153.758C24.5332 153.453 24.457 153.102 24.457 152.703H25.8691C25.8691 152.957 25.9277 153.182 26.0449 153.377C26.166 153.568 26.334 153.719 26.5488 153.828C26.7676 153.938 27.0176 153.992 27.2988 153.992C27.5957 153.992 27.8516 153.939 28.0664 153.834C28.2812 153.729 28.4453 153.572 28.5586 153.365C28.6758 153.158 28.7344 152.908 28.7344 152.615C28.7344 152.283 28.6699 152.014 28.541 151.807C28.4121 151.6 28.2285 151.447 27.9902 151.35C27.752 151.248 27.4707 151.197 27.1465 151.197H26.3027Z",
    fill: "#71757A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3848 198.02V199.414C23.3848 200.082 23.3184 200.652 23.1855 201.125C23.0566 201.594 22.8691 201.975 22.623 202.268C22.377 202.561 22.082 202.775 21.7383 202.912C21.3984 203.049 21.0176 203.117 20.5957 203.117C20.2598 203.117 19.9473 203.074 19.6582 202.988C19.373 202.902 19.1152 202.768 18.8848 202.584C18.6543 202.4 18.457 202.164 18.293 201.875C18.1328 201.582 18.0078 201.232 17.918 200.826C17.832 200.42 17.7891 199.949 17.7891 199.414V198.02C17.7891 197.348 17.8555 196.781 17.9883 196.32C18.1211 195.855 18.3105 195.479 18.5566 195.189C18.8027 194.896 19.0957 194.684 19.4355 194.551C19.7793 194.418 20.1621 194.352 20.584 194.352C20.9238 194.352 21.2363 194.395 21.5215 194.48C21.8105 194.562 22.0684 194.693 22.2949 194.873C22.5254 195.053 22.7207 195.287 22.8809 195.576C23.0449 195.861 23.1699 196.207 23.2559 196.613C23.3418 197.016 23.3848 197.484 23.3848 198.02ZM21.9727 199.613V197.809C21.9727 197.469 21.9531 197.17 21.9141 196.912C21.875 196.65 21.8164 196.43 21.7383 196.25C21.6641 196.066 21.5703 195.918 21.457 195.805C21.3438 195.688 21.2148 195.604 21.0703 195.553C20.9258 195.498 20.7637 195.471 20.584 195.471C20.3652 195.471 20.1699 195.514 19.998 195.6C19.8262 195.682 19.6816 195.814 19.5645 195.998C19.4473 196.182 19.3574 196.424 19.2949 196.725C19.2363 197.021 19.207 197.383 19.207 197.809V199.613C19.207 199.957 19.2266 200.26 19.2656 200.521C19.3047 200.783 19.3633 201.008 19.4414 201.195C19.5195 201.379 19.6133 201.531 19.7227 201.652C19.8359 201.77 19.9648 201.855 20.1094 201.91C20.2578 201.965 20.4199 201.992 20.5957 201.992C20.8184 201.992 21.0156 201.949 21.1875 201.863C21.3594 201.777 21.5039 201.641 21.6211 201.453C21.7383 201.262 21.8262 201.014 21.8848 200.709C21.9434 200.404 21.9727 200.039 21.9727 199.613ZM30.2051 198.02V199.414C30.2051 200.082 30.1387 200.652 30.0059 201.125C29.877 201.594 29.6895 201.975 29.4434 202.268C29.1973 202.561 28.9023 202.775 28.5586 202.912C28.2188 203.049 27.8379 203.117 27.416 203.117C27.0801 203.117 26.7676 203.074 26.4785 202.988C26.1934 202.902 25.9355 202.768 25.7051 202.584C25.4746 202.4 25.2773 202.164 25.1133 201.875C24.9531 201.582 24.8281 201.232 24.7383 200.826C24.6523 200.42 24.6094 199.949 24.6094 199.414V198.02C24.6094 197.348 24.6758 196.781 24.8086 196.32C24.9414 195.855 25.1309 195.479 25.377 195.189C25.623 194.896 25.916 194.684 26.2559 194.551C26.5996 194.418 26.9824 194.352 27.4043 194.352C27.7441 194.352 28.0566 194.395 28.3418 194.48C28.6309 194.562 28.8887 194.693 29.1152 194.873C29.3457 195.053 29.541 195.287 29.7012 195.576C29.8652 195.861 29.9902 196.207 30.0762 196.613C30.1621 197.016 30.2051 197.484 30.2051 198.02ZM28.793 199.613V197.809C28.793 197.469 28.7734 197.17 28.7344 196.912C28.6953 196.65 28.6367 196.43 28.5586 196.25C28.4844 196.066 28.3906 195.918 28.2773 195.805C28.1641 195.688 28.0352 195.604 27.8906 195.553C27.7461 195.498 27.584 195.471 27.4043 195.471C27.1855 195.471 26.9902 195.514 26.8184 195.6C26.6465 195.682 26.502 195.814 26.3848 195.998C26.2676 196.182 26.1777 196.424 26.1152 196.725C26.0566 197.021 26.0273 197.383 26.0273 197.809V199.613C26.0273 199.957 26.0469 200.26 26.0859 200.521C26.125 200.783 26.1836 201.008 26.2617 201.195C26.3398 201.379 26.4336 201.531 26.543 201.652C26.6562 201.77 26.7852 201.855 26.9297 201.91C27.0781 201.965 27.2402 201.992 27.416 201.992C27.6387 201.992 27.8359 201.949 28.0078 201.863C28.1797 201.777 28.3242 201.641 28.4414 201.453C28.5586 201.262 28.6465 201.014 28.7051 200.709C28.7637 200.404 28.793 200.039 28.793 199.613Z",
    fill: "#71757A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3848 246.02V247.414C23.3848 248.082 23.3184 248.652 23.1855 249.125C23.0566 249.594 22.8691 249.975 22.623 250.268C22.377 250.561 22.082 250.775 21.7383 250.912C21.3984 251.049 21.0176 251.117 20.5957 251.117C20.2598 251.117 19.9473 251.074 19.6582 250.988C19.373 250.902 19.1152 250.768 18.8848 250.584C18.6543 250.4 18.457 250.164 18.293 249.875C18.1328 249.582 18.0078 249.232 17.918 248.826C17.832 248.42 17.7891 247.949 17.7891 247.414V246.02C17.7891 245.348 17.8555 244.781 17.9883 244.32C18.1211 243.855 18.3105 243.479 18.5566 243.189C18.8027 242.896 19.0957 242.684 19.4355 242.551C19.7793 242.418 20.1621 242.352 20.584 242.352C20.9238 242.352 21.2363 242.395 21.5215 242.48C21.8105 242.562 22.0684 242.693 22.2949 242.873C22.5254 243.053 22.7207 243.287 22.8809 243.576C23.0449 243.861 23.1699 244.207 23.2559 244.613C23.3418 245.016 23.3848 245.484 23.3848 246.02ZM21.9727 247.613V245.809C21.9727 245.469 21.9531 245.17 21.9141 244.912C21.875 244.65 21.8164 244.43 21.7383 244.25C21.6641 244.066 21.5703 243.918 21.457 243.805C21.3438 243.688 21.2148 243.604 21.0703 243.553C20.9258 243.498 20.7637 243.471 20.584 243.471C20.3652 243.471 20.1699 243.514 19.998 243.6C19.8262 243.682 19.6816 243.814 19.5645 243.998C19.4473 244.182 19.3574 244.424 19.2949 244.725C19.2363 245.021 19.207 245.383 19.207 245.809V247.613C19.207 247.957 19.2266 248.26 19.2656 248.521C19.3047 248.783 19.3633 249.008 19.4414 249.195C19.5195 249.379 19.6133 249.531 19.7227 249.652C19.8359 249.77 19.9648 249.855 20.1094 249.91C20.2578 249.965 20.4199 249.992 20.5957 249.992C20.8184 249.992 21.0156 249.949 21.1875 249.863C21.3594 249.777 21.5039 249.641 21.6211 249.453C21.7383 249.262 21.8262 249.014 21.8848 248.709C21.9434 248.404 21.9727 248.039 21.9727 247.613ZM28.5 242.439V251H27.0879V244.115L24.9961 244.824V243.658L28.3301 242.439H28.5Z",
    fill: "#71757A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3848 294.02V295.414C23.3848 296.082 23.3184 296.652 23.1855 297.125C23.0566 297.594 22.8691 297.975 22.623 298.268C22.377 298.561 22.082 298.775 21.7383 298.912C21.3984 299.049 21.0176 299.117 20.5957 299.117C20.2598 299.117 19.9473 299.074 19.6582 298.988C19.373 298.902 19.1152 298.768 18.8848 298.584C18.6543 298.4 18.457 298.164 18.293 297.875C18.1328 297.582 18.0078 297.232 17.918 296.826C17.832 296.42 17.7891 295.949 17.7891 295.414V294.02C17.7891 293.348 17.8555 292.781 17.9883 292.32C18.1211 291.855 18.3105 291.479 18.5566 291.189C18.8027 290.896 19.0957 290.684 19.4355 290.551C19.7793 290.418 20.1621 290.352 20.584 290.352C20.9238 290.352 21.2363 290.395 21.5215 290.48C21.8105 290.562 22.0684 290.693 22.2949 290.873C22.5254 291.053 22.7207 291.287 22.8809 291.576C23.0449 291.861 23.1699 292.207 23.2559 292.613C23.3418 293.016 23.3848 293.484 23.3848 294.02ZM21.9727 295.613V293.809C21.9727 293.469 21.9531 293.17 21.9141 292.912C21.875 292.65 21.8164 292.43 21.7383 292.25C21.6641 292.066 21.5703 291.918 21.457 291.805C21.3438 291.688 21.2148 291.604 21.0703 291.553C20.9258 291.498 20.7637 291.471 20.584 291.471C20.3652 291.471 20.1699 291.514 19.998 291.6C19.8262 291.682 19.6816 291.814 19.5645 291.998C19.4473 292.182 19.3574 292.424 19.2949 292.725C19.2363 293.021 19.207 293.383 19.207 293.809V295.613C19.207 295.957 19.2266 296.26 19.2656 296.521C19.3047 296.783 19.3633 297.008 19.4414 297.195C19.5195 297.379 19.6133 297.531 19.7227 297.652C19.8359 297.77 19.9648 297.855 20.1094 297.91C20.2578 297.965 20.4199 297.992 20.5957 297.992C20.8184 297.992 21.0156 297.949 21.1875 297.863C21.3594 297.777 21.5039 297.641 21.6211 297.453C21.7383 297.262 21.8262 297.014 21.8848 296.709C21.9434 296.404 21.9727 296.039 21.9727 295.613ZM30.3633 297.875V299H24.6445V298.033L27.4219 295.004C27.7266 294.66 27.9668 294.363 28.1426 294.113C28.3184 293.863 28.4414 293.639 28.5117 293.439C28.5859 293.236 28.623 293.039 28.623 292.848C28.623 292.578 28.5723 292.342 28.4707 292.139C28.373 291.932 28.2285 291.77 28.0371 291.652C27.8457 291.531 27.6133 291.471 27.3398 291.471C27.0234 291.471 26.7578 291.539 26.543 291.676C26.3281 291.812 26.166 292.002 26.0566 292.244C25.9473 292.482 25.8926 292.756 25.8926 293.064H24.4805C24.4805 292.568 24.5938 292.115 24.8203 291.705C25.0469 291.291 25.375 290.963 25.8047 290.721C26.2344 290.475 26.752 290.352 27.3574 290.352C27.9277 290.352 28.4121 290.447 28.8105 290.639C29.209 290.83 29.5117 291.102 29.7188 291.453C29.9297 291.805 30.0352 292.221 30.0352 292.701C30.0352 292.967 29.9922 293.23 29.9062 293.492C29.8203 293.754 29.6973 294.016 29.5371 294.277C29.3809 294.535 29.1953 294.795 28.9805 295.057C28.7656 295.314 28.5293 295.576 28.2715 295.842L26.4258 297.875H30.3633Z",
    fill: "#71757A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3848 342.02V343.414C23.3848 344.082 23.3184 344.652 23.1855 345.125C23.0566 345.594 22.8691 345.975 22.623 346.268C22.377 346.561 22.082 346.775 21.7383 346.912C21.3984 347.049 21.0176 347.117 20.5957 347.117C20.2598 347.117 19.9473 347.074 19.6582 346.988C19.373 346.902 19.1152 346.768 18.8848 346.584C18.6543 346.4 18.457 346.164 18.293 345.875C18.1328 345.582 18.0078 345.232 17.918 344.826C17.832 344.42 17.7891 343.949 17.7891 343.414V342.02C17.7891 341.348 17.8555 340.781 17.9883 340.32C18.1211 339.855 18.3105 339.479 18.5566 339.189C18.8027 338.896 19.0957 338.684 19.4355 338.551C19.7793 338.418 20.1621 338.352 20.584 338.352C20.9238 338.352 21.2363 338.395 21.5215 338.48C21.8105 338.562 22.0684 338.693 22.2949 338.873C22.5254 339.053 22.7207 339.287 22.8809 339.576C23.0449 339.861 23.1699 340.207 23.2559 340.613C23.3418 341.016 23.3848 341.484 23.3848 342.02ZM21.9727 343.613V341.809C21.9727 341.469 21.9531 341.17 21.9141 340.912C21.875 340.65 21.8164 340.43 21.7383 340.25C21.6641 340.066 21.5703 339.918 21.457 339.805C21.3438 339.688 21.2148 339.604 21.0703 339.553C20.9258 339.498 20.7637 339.471 20.584 339.471C20.3652 339.471 20.1699 339.514 19.998 339.6C19.8262 339.682 19.6816 339.814 19.5645 339.998C19.4473 340.182 19.3574 340.424 19.2949 340.725C19.2363 341.021 19.207 341.383 19.207 341.809V343.613C19.207 343.957 19.2266 344.26 19.2656 344.521C19.3047 344.783 19.3633 345.008 19.4414 345.195C19.5195 345.379 19.6133 345.531 19.7227 345.652C19.8359 345.77 19.9648 345.855 20.1094 345.91C20.2578 345.965 20.4199 345.992 20.5957 345.992C20.8184 345.992 21.0156 345.949 21.1875 345.863C21.3594 345.777 21.5039 345.641 21.6211 345.453C21.7383 345.262 21.8262 345.014 21.8848 344.709C21.9434 344.404 21.9727 344.039 21.9727 343.613ZM26.3027 342.096H27.1465C27.4746 342.096 27.7461 342.039 27.9609 341.926C28.1797 341.812 28.3418 341.656 28.4473 341.457C28.5527 341.258 28.6055 341.029 28.6055 340.771C28.6055 340.502 28.5566 340.271 28.459 340.08C28.3652 339.885 28.2207 339.734 28.0254 339.629C27.834 339.523 27.5898 339.471 27.293 339.471C27.043 339.471 26.8164 339.521 26.6133 339.623C26.4141 339.721 26.2559 339.861 26.1387 340.045C26.0215 340.225 25.9629 340.439 25.9629 340.689H24.5449C24.5449 340.236 24.6641 339.834 24.9023 339.482C25.1406 339.131 25.4648 338.855 25.875 338.656C26.2891 338.453 26.7539 338.352 27.2695 338.352C27.8203 338.352 28.3008 338.443 28.7109 338.627C29.125 338.807 29.4473 339.076 29.6777 339.436C29.9082 339.795 30.0234 340.24 30.0234 340.771C30.0234 341.014 29.9668 341.26 29.8535 341.51C29.7402 341.76 29.5723 341.988 29.3496 342.195C29.127 342.398 28.8496 342.564 28.5176 342.693C28.1855 342.818 27.8008 342.881 27.3633 342.881H26.3027V342.096ZM26.3027 343.197V342.424H27.3633C27.8633 342.424 28.2891 342.482 28.6406 342.6C28.9961 342.717 29.2852 342.879 29.5078 343.086C29.7305 343.289 29.8926 343.521 29.9941 343.783C30.0996 344.045 30.1523 344.322 30.1523 344.615C30.1523 345.014 30.0801 345.369 29.9355 345.682C29.7949 345.99 29.5938 346.252 29.332 346.467C29.0703 346.682 28.7637 346.844 28.4121 346.953C28.0645 347.062 27.6855 347.117 27.2754 347.117C26.9082 347.117 26.5566 347.066 26.2207 346.965C25.8848 346.863 25.584 346.713 25.3184 346.514C25.0527 346.311 24.8418 346.059 24.6855 345.758C24.5332 345.453 24.457 345.102 24.457 344.703H25.8691C25.8691 344.957 25.9277 345.182 26.0449 345.377C26.166 345.568 26.334 345.719 26.5488 345.828C26.7676 345.938 27.0176 345.992 27.2988 345.992C27.5957 345.992 27.8516 345.939 28.0664 345.834C28.2812 345.729 28.4453 345.572 28.5586 345.365C28.6758 345.158 28.7344 344.908 28.7344 344.615C28.7344 344.283 28.6699 344.014 28.541 343.807C28.4121 343.6 28.2285 343.447 27.9902 343.35C27.752 343.248 27.4707 343.197 27.1465 343.197H26.3027Z",
    fill: "#71757A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7791 18.2225H19.2227V37.7789H38.7791V18.2225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4941 25.2626L31.3902 26.5427L32.7982 25.5186V32.9429H34.3343V23.2145H33.0543L30.4941 25.2626Z",
    fill: "#1E88E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0612 27.774C28.6168 27.2637 28.9617 26.5562 28.9617 25.7748C28.9617 24.2218 27.599 22.9587 25.9242 22.9587C24.5002 22.9587 23.2823 23.8556 22.9641 25.1392L24.4371 25.5134C24.5837 24.9232 25.2086 24.4947 25.9242 24.4947C26.7616 24.4947 27.4434 25.069 27.4434 25.7748C27.4434 26.4806 26.7616 27.0548 25.9242 27.0548H25.038V28.5909H25.9242C26.8852 28.5909 27.6959 29.2585 27.6959 30.0488C27.6959 30.8523 26.9261 31.5066 25.9793 31.5066C25.1242 31.5066 24.3935 30.9643 24.2779 30.2461L22.7783 30.4914C23.0112 31.9457 24.3873 33.0427 25.9785 33.0427C27.7625 33.0427 29.2142 31.6995 29.2142 30.0488C29.2142 29.1394 28.7661 28.3233 28.0612 27.774Z",
    fill: "#1E88E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8901 44.0016H20.1116L19.2227 40.4459L20.1116 36.8902H37.8901L38.7791 40.4459L37.8901 44.0016Z",
    fill: "#FBC02D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4444 37.7789L45.0001 36.89V19.1114L41.4444 18.2225L37.8887 19.1114V36.89L41.4444 37.7789Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.89 19.1114L38.7789 15.5557L37.89 12H15.6668C14.1938 12 13 13.1938 13 14.6668V36.89L16.5557 37.7789L20.1114 36.89V19.1114H37.89Z",
    fill: "#1E88E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8887 36.8902V44.0016L45.0001 36.8902H37.8887Z",
    fill: "#E53935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3333 12H37.8887V19.1114H45.0001V14.6668C45.0001 13.1938 43.8063 12 42.3333 12Z",
    fill: "#1565C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6668 44.0016H20.1114V36.8902H13V41.3348C13 42.8077 14.1938 44.0016 15.6668 44.0016Z",
    fill: "#1565C0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 102.5,
    x2: 39,
    y2: 102.5,
    stroke: "#DADCE0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 150.5,
    x2: 39,
    y2: 150.5,
    stroke: "#DADCE0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 198.5,
    x2: 39,
    y2: 198.5,
    stroke: "#DADCE0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 246.5,
    x2: 39,
    y2: 246.5,
    stroke: "#DADCE0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 294.5,
    x2: 39,
    y2: 294.5,
    stroke: "#DADCE0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 342.5,
    x2: 39,
    y2: 342.5,
    stroke: "#DADCE0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 54.5,
    x2: 1,
    y2: 54.5,
    stroke: "url(#paint0_linear_1780_27988)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 103,
    width: 449,
    height: 321,
    rx: 4,
    fill: "#203364",
    fillOpacity: 0.1,
    stroke: "#203364",
    strokeWidth: 2,
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.583 114.333C58.7392 114.333 58.0552 115.016 58.0552 115.857V118.143C58.0552 118.564 58.3972 118.905 58.8191 118.905H59.965L59.965 117.762C59.965 117.044 59.965 116.684 60.1887 116.461C60.4124 116.238 60.7725 116.238 61.4927 116.238H62.6386C63.3588 116.238 63.7189 116.238 63.9426 116.461C64.1663 116.684 64.1663 117.044 64.1663 117.762V118.905H65.833L65.833 117.762C65.833 117.044 65.833 116.684 66.0567 116.461C66.2805 116.238 66.6406 116.238 67.3608 116.238H68.5066C69.2268 116.238 69.5869 116.238 69.8107 116.461C70.0344 116.684 70.0344 117.044 70.0344 117.762V118.905H71.1802C71.6021 118.905 71.9441 118.564 71.9441 118.143V115.857C71.9441 115.016 71.2601 114.333 70.4163 114.333H59.583Z",
    fill: "#203364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7092 120.048C58.0161 120.048 55.833 122.231 55.833 124.924C55.833 125.597 56.3788 126.143 57.0521 126.143H57.3607L57.3607 127.007C57.3607 127.371 57.7028 127.667 58.1246 127.667C58.5465 127.667 58.8885 127.371 58.8885 127.007L58.8885 126.143H71.1107V127.007C71.1107 127.371 71.4528 127.667 71.8746 127.667C72.2965 127.667 72.6385 127.371 72.6385 127.007V126.143H72.9473C73.6206 126.143 74.1663 125.597 74.1663 124.924C74.1663 122.231 71.9832 120.048 69.2901 120.048H60.7092Z",
    fill: "#203364"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 497,
    height: 391,
    rx: 16.5,
    stroke: "#DADCE0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1780_27988",
    x: 47,
    y: 55,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1780_27988",
    result: "effect2_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1780_27988",
    x: 137,
    y: 55,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1780_27988",
    x: 227,
    y: 55,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_1780_27988",
    x: 317,
    y: 55,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_1780_27988",
    x: 407,
    y: 55,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_1780_27988",
    x: 47,
    y: 103,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1780_27988",
    result: "effect2_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_1780_27988",
    x: 137,
    y: 103,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_1780_27988",
    x: 227,
    y: 103,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_1780_27988",
    x: 317,
    y: 103,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_1780_27988",
    x: 407,
    y: 103,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_ii_1780_27988",
    x: 47,
    y: 151,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1780_27988",
    result: "effect2_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_1780_27988",
    x: 137,
    y: 151,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_i_1780_27988",
    x: 227,
    y: 151,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_i_1780_27988",
    x: 317,
    y: 151,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_i_1780_27988",
    x: 407,
    y: 151,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_ii_1780_27988",
    x: 47,
    y: 199,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1780_27988",
    result: "effect2_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_i_1780_27988",
    x: 137,
    y: 199,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_i_1780_27988",
    x: 227,
    y: 199,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_i_1780_27988",
    x: 317,
    y: 199,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_i_1780_27988",
    x: 407,
    y: 199,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_ii_1780_27988",
    x: 47,
    y: 247,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1780_27988",
    result: "effect2_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_i_1780_27988",
    x: 137,
    y: 247,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_i_1780_27988",
    x: 227,
    y: 247,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_i_1780_27988",
    x: 317,
    y: 247,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_i_1780_27988",
    x: 407,
    y: 247,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_ii_1780_27988",
    x: 47,
    y: 295,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1780_27988",
    result: "effect2_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_i_1780_27988",
    x: 137,
    y: 295,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_i_1780_27988",
    x: 227,
    y: 295,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_i_1780_27988",
    x: 317,
    y: 295,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_i_1780_27988",
    x: 407,
    y: 295,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_ii_1780_27988",
    x: 47,
    y: 343,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1780_27988",
    result: "effect2_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_i_1780_27988",
    x: 137,
    y: 343,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_i_1780_27988",
    x: 227,
    y: 343,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_i_1780_27988",
    x: 317,
    y: 343,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_i_1780_27988",
    x: 47,
    y: 1,
    width: 450,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_27988"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1780_27988",
    x1: 47,
    y1: 55,
    x2: 0.999999,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DADCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADCE0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1780_27988"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 496,
    height: 390,
    rx: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2);
export default __webpack_public_path__ + "static/media/frame2.a9e8107c1127f0a7fb58e3e14081e218.svg";
export { ForwardRef as ReactComponent };